import {useEffect} from "react";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { AuthInit } from "./modules/auth";
import { ThemeModeProvider } from "../_metronic/partials";
import { TourGuideProvider } from "./modules/auth/core/TourGuideContext";
import RayChat from "raychat-react";
import AiAssistant from "./modules/aiAssistant/components/AskAiAssisstant";

const App = () => {
  const token = "1b271cf9-126b-49ed-aad0-c6583729b3f4";
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <TourGuideProvider>
              <AuthInit>
                <Outlet />
                {/* <RayChat rayToken={token} /> */}
                <AiAssistant />
                <MasterInit />
              </AuthInit>
            </TourGuideProvider>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
